import * as React from "react";

const GVRightArrow: React.FC = () => {
    return (
        <svg width="17" height="8" viewBox="0 0 17 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 3.18201C0.223858 3.18201 2.41411e-08 3.40586 0 3.68201C-2.41411e-08 3.95815 0.223858 4.18201 0.5 4.18201L0.5 3.68201L0.5 3.18201ZM16.8536 4.03556C17.0488 3.8403 17.0488 3.52372 16.8536 3.32845L13.6716 0.146474C13.4763 -0.0487881 13.1597 -0.0487882 12.9645 0.146474C12.7692 0.341736 12.7692 0.658319 12.9645 0.853581L15.7929 3.68201L12.9645 6.51044C12.7692 6.7057 12.7692 7.02228 12.9645 7.21754C13.1597 7.4128 13.4763 7.4128 13.6716 7.21754L16.8536 4.03556ZM0.5 3.68201L0.5 4.18201L16.5 4.18201L16.5 3.68201L16.5 3.18201L0.5 3.18201L0.5 3.68201Z" fill="#1C1917"/>
        </svg>
    );
};

export default React.memo(GVRightArrow);
